export default "__VITE_ASSET__Bnr_0fQz__"